import { __read } from 'tslib';
import { transform } from '../utils/transform.js';
import { useCombineMotionValues } from './use-combine-values.js';
import { useConstant } from '../utils/use-constant.js';

function useTransform(input, inputRangeOrTransformer, outputRange, options) {
  var transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : transform(inputRangeOrTransformer, outputRange, options);
  return Array.isArray(input) ? useListTransform(input, transformer) : useListTransform([input], function (_a) {
    var _b = __read(_a, 1),
        latest = _b[0];

    return transformer(latest);
  });
}

function useListTransform(values, transformer) {
  var latest = useConstant(function () {
    return [];
  });
  return useCombineMotionValues(values, function () {
    latest.length = 0;
    var numValues = values.length;

    for (var i = 0; i < numValues; i++) {
      latest[i] = values[i].get();
    }

    return transformer(latest);
  });
}

export { useTransform };